import React, {useState, useEffect } from "react";
import { Row } from 'react-bootstrap';
import { getCategoriesByID, DeletePub } from "../auth/apiCategory";
import { isAuthenticated } from '../auth';
import imgLakay from '../Layout/imgs/Untitled-2.jpg';
import imgProductLakay from '../Layout/imgs/md3.jpg' 
import PuB1500 from './Pub1500X500'
import PuB500 from './PubR400x400'
import PuB400 from './PubC400X400'
import { elakay_API } from "../../config";
import { FaLongArrowAltLeft, FaDesktop, FaMobileAlt  } from "react-icons/fa";
import { MdDeleteForever, MdEdit, MdLibraryAdd, MdCancel} from "react-icons/md";
import {decryptData}  from '../auth/elakayCryptage'
// import { Family, Adminstrator } from "../pageInside/Rolle"
const categoyseleted = [];
const categoyIDseleted = [];

const PubProducts = props => {
    const {
        laguangeElakay,
        infoSource
        } = props
    const [getSize, setSize] = useState('d');
    const [categories, setCategories] = useState([])
    const [getpub, setPub] = useState([]);
    const [getpubC, setPubC] = useState([]);
    const [getpubR, setPubR] = useState([]);
    // const [loading, setLoading] = useState(true);
    const [elakayCategoryID, setElakayCategoryID] = useState('5ed4946fd2ba8812c20261a8');
    const [imagePubID, setImagePubID] = useState(null);
    const [imgEdit, setEmgEdit] = useState(undefined);
    const { token } = isAuthenticated();
    const [pubShowNav, setPubShowNav] = useState({
        showPuB1500X400FT: false,
        showPuB500X500FT:false,
        showPuB400X400FT:false
    })

    const {
        showPuB1500X400FT,
        showPuB500X500FT,
        showPuB400X400FT
    } = pubShowNav

    
    
    // let elakayCategoryID = categories._id ? categories._id: '5ed4946fd2ba8812c20261a8'

    const loadCategory = async (ID) => {
        
                try {
                      const encryptedData = await getCategoriesByID(ID);
                      const data = encryptedData;
                         if (data.error) {
                            console.log(data.error);
                            throw new Error(data.error)
                            } else {
                            setElakayCategoryID(data.cartegory._id)
                            setCategories(data.cartegory)
                            setPub(data.pub)
                            setPubR(data.pub_R)
                            setPubC(data.pub_C)
                            // setLoading(false)
                        }
                   } catch (err) {
            console.error("Erreur lors du chargement de l'utilisateur :", err);
          }
    };

    useEffect(() => {
        loadCategory(elakayCategoryID)
    }, [elakayCategoryID]);

    const seleteCategory = () => event => {
        const supcategory = event.target.value;
        categoyseleted.push(categories.name)
        categoyIDseleted.push(categories._id)
        loadCategory(supcategory)
    }

    const clickBack =(LA)=>{
        loadCategory(LA)
        categoyIDseleted.pop()
        categoyseleted.pop()
    }

    const ButtonBackCategory = () => {
        let last_le = categoyIDseleted[categoyIDseleted.length - 1]

        return (
            <span onClick={() => clickBack(last_le) } className="h5 float-left">
                <FaLongArrowAltLeft />
            </span>
        )
    }

    const selectProduct = () => (
        <div className="container">
        <form className="mb-3">
            <div className="form-group">
                <div className="boxCategory1 text-center " id="heading">
                        <h2> {ButtonBackCategory()} {categories.name} </h2>
                        {categoyseleted.map((l, j) => (<p className="d-inline" key={j}>{l}{" / "}</p>))}
                </div>
                <select value={0} onChange={seleteCategory()} className="form-control">
                    <option>{infoSource.laguangeElakay('label', infoSource.languageAPI).selectProdSell}</option>
                    {categories.items && categories.items.map((c, i) => (
                        <option key={i} value={c.supCategoryID._id}>
                            {/* {c.supCategoryID.name} */}
                            {infoSource.getCategoryNames(c).name}
                        </option>
                    ))}
                </select>
            </div>
           
        </form> 
        </div>
    )

    const ButtonPuB1500X400 = (img = false) => {
       img && setImagePubID(null)
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: true,
            showPuB500X500FT: false,
            showPuB400X400FT: false,
            shooseTypeOfPubFT: false,
        })
    };

    const ButtonPuB500X500 = () => {
        setImagePubID(null)
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: false,
            showPuB500X500FT: true,
            showPuB400X400FT: false,
            shooseTypeOfPubFT: false,
        })
    };
    const ButtonPuB400X400 = () => {
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: false,
            showPuB500X500FT: false,
            showPuB400X400FT: true,
            shooseTypeOfPubFT: false,
        })
    };

    const ButtonCancel = () => {
        setPubShowNav({
            ...pubShowNav,
            showPuB1500X400FT: false,
            showPuB500X500FT: false,
            showPuB400X400FT: false,
            shooseTypeOfPubFT: true,
        })
    };
const boxStyle = {
    maxHeight: '400px',
    overflowY: 'auto',
    border: '1px solid #ccc',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.05)'
};

const containerStyle = {
   display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px'
};

 const headingStyle = {
    fontSize: '1.2rem',
    marginBottom: '15px',
    color: '#333'
  };

  const rowStyle = {
     display: 'flex',
  flexWrap: 'wrap',
  gap: '15px',
  marginBottom: '15px',
//   height: '300px', // définit la hauteur de la row'
  
  };

  const getBoxStyle = () => {
    return {
      flex: '1 1 100%',
      '@media (min-width: 500px)': { flex: '1 1 45%' },
      '@media (min-width: 768px)': { flex: '1 1 30%' }
    };
  };

  const imageStyle = {
   width: '100%',
  height: '100%', // prend toute la hauteur de la row
  objectFit: 'cover',
  borderRadius: '6px',
  transition: 'transform 0.3s ease'
  };

    const ImageSizeSelector = () => {
  return (
    <div style={{ display: 'flex', gap: '1rem', margin: '20px 0' }}>
      <label
        onClick={() => setSize("d")}
        style={{
          border: getSize === "d" ? "2px solid #007bff" : "1px solid #ccc",
          padding: "10px 20px",
          borderRadius: "8px",
          backgroundColor: getSize === "d" ? "#e7f1ff" : "#f9f9f9",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <input
          type="radio"
          name="imageSize"
          value="d"
          checked={getSize === "d"}
          onChange={() => setSize("d")}
          style={{ display: "none" }}
        />
        <FaDesktop />
        Desktop & Tablet
      </label>

      <label
        onClick={() => setSize("m")}
        style={{
          border: getSize === "m" ? "2px solid #007bff" : "1px solid #ccc",
          padding: "10px 20px",
          borderRadius: "8px",
          backgroundColor: getSize === "m" ? "#e7f1ff" : "#f9f9f9",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <input
          type="radio"
          name="imageSize"
          value="m"
          checked={getSize === "m"}
          onChange={() => setSize("m")}
          style={{ display: "none" }}
        />
        <FaMobileAlt />
        Mobile
      </label>

          <label
        onClick={() => setSize("m")}
        style={{
          border: "1px solid #ccc",
          padding: !imagePubID ?"10px 20px" : "10px 5px",
          borderRadius: "8px",
        //   backgroundColor: getSize === "m" ? "#e7f1ff" : "#f9f9f9",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <input
          type="radio"
          name="imageSize"
          value="m"
          style={{ display: "none" }}
        />
       {!imagePubID?
        <MdLibraryAdd />
        :
        <MdEdit/>}
        {imagePubID && <img
                            src={imgEdit}
                            alt={imgEdit}
                            style={{width: "70px" }}
                        />}
      </label>
    </div>
  );
};

  const shoosePuB = ()=>(
      <div className="container">

        <Row xs={1} sm={2} md={3} lg={3} xl={3} >
            <div>
                  <div className="m-4">
                      <div className="mb-3" style={{ height: "100px", maxWidth:"280px"}}>
                  <img
                      className="rounded"
                      src={imgLakay}
                      alt={"imgage Lakay"}
                      style={{ width: "100%" }}
                  /> 
                 </div>
                      <button className="btn btn-primary float-left pt-2 pb-2 pr-2 pl-2" onClick={ButtonPuB1500X400}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).creatPub}</button>
</div>
            </div>
            <div>
              <div className="m-4">
                      <div className="mb-3" style={{ height: "117px", width: "117px"}}>
                 <img
                      className="rounded"
                      src={imgProductLakay}
                      alt={"imgage Lakay"}
                      style={{ height: "100%", width: "100%" }}
                  />  
                  </div>
                      <button className="btn btn-primary float-left pt-2 pb-2 pr-2 pl-2" onClick={ButtonPuB500X500}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).creatPub}</button>
                  </div>
              </div>
              {
                  elakayCategoryID !== "5ed4946fd2ba8812c20261a8" && (
              <div> 
                  <div className="m-4">
                      <div className="mb-3" style={{ height: "117px", width: "117px" }}>
                  <img
                      className="rounded-circle"
                      src={imgProductLakay}
                      alt={"imgage Lakay"}
                      style={{ height: "100%", width: "100%" }}
                  />
                    </div>
                      <button className="btn btn-primary float-left pt-2 pb-2 pr-2 pl-2" onClick={ButtonPuB400X400}>{infoSource.laguangeElakay('Button', infoSource.languageAPI).creatPub}</button> 
                    </div>
              </div>
                  )}
        </Row>
      </div>
  )

  const showPub1500 =()=>(
      showPuB1500X400FT && (
        <>
       
          <PuB1500
              elakayCategoryID={elakayCategoryID}
              loadCategory={loadCategory}
              ButtonCancel={ButtonCancel}
              laguangeElakay={laguangeElakay}
              infoSource={infoSource}
              getSize={getSize} 
              setSize={setSize}
              imagePubID={imagePubID}
              ImageSizeSelector={ImageSizeSelector}
          /></>
      )
  )
    const showPuB500 = () => (
        showPuB500X500FT && (
     
            <PuB500
                elakayCategoryID={elakayCategoryID}
                loadCategory={loadCategory}
                ButtonCancel={ButtonCancel}
                laguangeElakay={laguangeElakay}
                infoSource={infoSource}
                getSize={getSize} 
                setSize={setSize}
                ImageSizeSelector={ImageSizeSelector}
            />
      )
    )

    const showPuB400= () => (
        showPuB400X400FT && (
            <PuB400 
                elakayCategoryID={elakayCategoryID}
                loadCategory={loadCategory}
                ButtonCancel={ButtonCancel}
                laguangeElakay={laguangeElakay}
                infoSource={infoSource}
            />
      )
    )

    const deleteImage = (categoryID, pubID, pub) => {
        DeletePub(token, categoryID, pubID, pub).then(data => {
            if (data.error) {
                console.log(data.error)
            } else {
            
                loadCategory(categoryID)
            }
        });
    };

    const loadPub1500x500 =()=>(
        getpub.length > 0 && (
        <div className="container mt-3 mb-3" style={boxStyle}>
           <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
         <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).pub1500x500}</h3>
                </div>
            <Row xs={1} sm={2} md={3} lg={3} xl={3}>
            {
                    getpub.map((p, i)=>(
                        <div  key={i} className="p-1"    style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    ...(window.innerWidth >= 768
                      ? { flex: '1 1 30%' }
                      : window.innerWidth >= 500
                      ? { flex: '1 1 45%' }
                      : {})
                  }}>
                            <div style={{ position: "relative", overflow: "hidden", transition: "0.3s", width: "100%" }}>
                        <img
                            className="rounded"
                            src={p.urlImg}
                            alt={p.user}
                            style={{ height: "100%", width: "100%" }}
                        />
                        <div 
                         style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        backgroundColor: 'rgba(255,255,255,0.6)',
                        fontSize: '25px',
                        color: 'blue',
                        borderRadius: '50%',
                        padding: '0',
                        cursor: 'pointer'
                        }}
                        >
                                    <MdDeleteForever onClick={() => deleteImage(elakayCategoryID, p._id, 1)} />

                        </div>
                        <div 
                            style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            backgroundColor: 'rgba(255,255,255,0.6)',
                            fontSize: '25px',
                            color: 'blue',
                            borderRadius: '50%',
                            padding: '0',
                            cursor: 'pointer'
                            }}
                        >
                           {imagePubID !== p._id ?
                                    <MdEdit onClick={() => {setImagePubID(p._id); ButtonPuB1500X400(); setEmgEdit(p.urlImg)}} />

                                    :
                               <MdCancel onClick={() => {setImagePubID(null); ButtonCancel()}}/>  }  

                        </div>
    <div 
                            style={{
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                            backgroundColor: 'rgba(255,255,255,0.6)',
                            fontSize: '25px',
                            color: 'blue',
                            // borderRadius: '50%',
                            padding: '0',
                            cursor: 'pointer'
                            }}
                        >
                         <h6>Desktop/Tablet</h6>
                        </div>
                        
                </div>
                    
                    
                    <div style={{ position: "relative", overflow: "hidden", transition: "0.3s", width: "100%" }}>
                        <img
                            className="rounded"
                            src={p.urlImg + "?size=m"}
                            alt={p.user}
                            style={{ height: "100%", width: "100%" }}
                        />
                        <div 
                         style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        backgroundColor: 'rgba(255,255,255,0.6)',
                        fontSize: '25px',
                        color: 'blue',
                        borderRadius: '50%',
                        padding: '0',
                        cursor: 'pointer'
                        }}
                        >
                                    <MdDeleteForever onClick={() => deleteImage(elakayCategoryID, p._id, 1)} />

                        </div>
                        <div 
                            style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            backgroundColor: 'rgba(255,255,255,0.6)',
                            fontSize: '25px',
                            color: 'blue',
                            borderRadius: '50%',
                            padding: '0',
                            cursor: 'pointer'
                            }}
                        >
                           {imagePubID !== p._id ?
                                    <MdEdit onClick={() => {setImagePubID(p._id); ButtonPuB1500X400(); setEmgEdit(p.urlImg)}} />

                                    :
                               <MdCancel onClick={() => {setImagePubID(null); ButtonCancel()}}/>  }  

                        </div>
                           <div 
                            style={{
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                            backgroundColor: 'rgba(255,255,255,0.6)',
                            fontSize: '25px',
                            color: 'blue',
                            // borderRadius: '50%',
                            padding: '0',
                            cursor: 'pointer'
                            }}
                        >
                         <h6>Mobile</h6>
                        </div>
                </div>
                </div>
                    ))
                   
            }
                 
            </Row>
        </div>

    ))

    const loadPub600x600 = () => (
   
        getpubR &&  getpubR.urlImg &&   <div className="container mt-3 mb-3" style={boxStyle}>
            <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
                <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).pub600x600}</h3>
            </div>
            <Row xs={1} sm={2} md={3} lg={3} xl={3}>     
                <div className="p-1"  style={rowStyle}>
                            <div style={{ 
                                flex: '1 1 100%',
                                position: "relative", 
                                overflow: "hidden", 
                                transition: "0.3s", 
                                 maxWidth: '100%',
                                ...(window.innerWidth >= 768
                      ? { flex: '1 1 30%' }
                      : window.innerWidth >= 500
                      ? { flex: '1 1 45%' }
                      : {})
                                 }}>
                                <img
                                    className="rounded"
                                    src={getpubR.urlImg + "?size=d"}
                                    alt={getpubR.user}
                                    // style={imageStyle}
                                    style={{ 
                                     boxShadow: '1px 4px 8px rgba(0,0,0,0.09)',
                                      width: '70%',
                                    // height: '100%', // prend toute la hauteur de la row
                                    objectFit: 'cover',
                                    borderRadius: '6px',
                                    transition: 'transform 0.3s ease'}}
                                      onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                />
                               <h6 style={headingStyle}>Desktop / Tablet</h6>
                                <div style={{ float: "right", position: "absolute", top: "0", magirn: "0", padding: "0", backgroundColor: "rgba(255,255,255,0.1)", fontSize: "25px", color: "blue" }}>
                                    <MdDeleteForever onClick={() => deleteImage(elakayCategoryID,  getpubR._id, 3)} />
                               </div>
                            </div> 
                            
                    </div>
                <div className="p-1" style={rowStyle}>
                            <div style={{           
                                flex: '1 1 100%',
                                position: "relative", 
                                overflow: "hidden", 
                                transition: "0.3s", 
                                 maxWidth: '100%',
                                ...(window.innerWidth >= 768
                      ? { flex: '1 1 30%' }
                      : window.innerWidth >= 500
                      ? { flex: '1 1 45%' }
                      : {})
                      }}>
                                <img
                                    className="rounded"
                                    src={getpubR.urlImg + "?size=m"}
                                    alt={getpubR.user}
                                    // style={imageStyle}
                                    style={{ boxShadow: '1px 4px 8px rgba(0,0,0,0.09)', height: "50%" }}
                                      onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                />
                               <h6 style={headingStyle}>Mobile</h6>
                                <div style={{ float: "right", position: "absolute", top: "0", magirn: "0", padding: "0", backgroundColor: "rgba(255,255,255,0.1)", fontSize: "25px", color: "blue" }}>
                                    <MdDeleteForever onClick={() => deleteImage(elakayCategoryID,  getpubR._id, 3)} />
                               </div>
                            </div> 
                            
                    </div>

            </Row>
            
        </div>
    )

    const loadPub400x400 = () => (
       
  getpubC &&  getpubC.urlImg &&  <div className="container mt-3 mb-3" style={boxStyle}>
            <div className="col text-center" style={{ backgroundColor: "WhiteSmoke" }}>
                <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).pub400x400}</h3>
            </div>
            <Row xs={1} sm={2} md={3} lg={3} xl={3}>
                
                        <div className="p-1"   style={rowStyle}>
                            <div style={{           
                                flex: '1 1 100%',
                                position: "relative", 
                                overflow: "hidden", 
                                transition: "0.3s", 
                                 maxWidth: '100%',
                      }}>
                                <img
                                    className="rounded-circle"
                                    src={getpubC.urlImg}
                                    alt={getpubC.user}
                                    style={{width: "70%" }}
                                     onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                />
                                <div style={{ float: "right", position: "absolute", top: "0", magirn: "0", padding: "0", backgroundColor: "rgba(255,255,255,0.1)", fontSize: "25px", color: "blue" }}>
                                    <MdDeleteForever onClick={() => deleteImage(elakayCategoryID, getpubC._id, 2)} />
                                </div>
                            </div></div>
           

            </Row>
        </div>
    )

    return (
        <div>
        {selectProduct()}
        {shoosePuB()}
        {showPub1500()}
        {showPuB500()}
        {showPuB400()} 
        <div style={containerStyle}>
        {loadPub1500x500()}
        {loadPub600x600()}
        {loadPub400x400()}
        </div>
      
        </div>
    )
};

export default PubProducts;